import { makeStyles, lighten } from "@material-ui/core/styles";

import {
  blueGrey,
  deepPurple,
  indigo,
  lightBlue,
  cyan,
  teal,
  green,
  grey,
  red,
  orange,
} from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  // Same card style as Booking Dashboard
  paper: {
    width: "100%",
    height: "90px",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
    },

    "& span": {
      fontSize: 35,
      fontWeight: 100,
      fontFamily: "Montserrat, sans-serif",
    },
  },

  // Same count style
  count: {
    fontWeight: 300,
    fontFamily: "Montserrat, sans-serif",
  },

  // Same name style
  nameDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    minWidth: 0,
    paddingRight: "10px",

    "& h6": {
      fontSize: 12,
      fontWeight: 400,
      textTransform: "capitalize",
      lineHeight: 1.3,

      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
  },

  // ==========================================
  // Interpreter Dashboard Colors
  // ==========================================

  total: {
    color: deepPurple[500],
    backgroundColor: deepPurple[100],
  },

  active: {
    color: green[500],
    backgroundColor: green[100],
  },

  translator: {
    color: lightBlue[500],
    backgroundColor: lightBlue[100],
  },

  transcriber: {
    color: cyan[500],
    backgroundColor: cyan[100],
  },

  interpreter: {
    color: indigo[500],
    backgroundColor: indigo[100],
  },

  // ==========================================
  // Expired Documents
  // ==========================================

  danger: {
    color: red[500],
    backgroundColor: red[100],
  },

  // ==========================================
  // Expiring Documents
  // ==========================================

  warning: {
    color: orange[500],
    backgroundColor: orange[100],
  },

  // ==========================================
  // Birthday Section
  // ==========================================

  birthday: {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
  },

  birthdayAvatar: {
    color: deepPurple[500],
    backgroundColor: deepPurple[100],
  },
}));
